import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../utils/analytics';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    // Deferred so Helmet has written the new <title> before it is read.
    const timer = window.setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 0);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
